// Moretti: solo animazioni richieste dal contenuto, rispettando la riduzione movimento.
(() => {
  function init(root = document) {
    const elements = root.querySelectorAll('.animate-on-scroll');
    if (!elements.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      elements.forEach(element => element.classList.add('animated'));
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('animated');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.1 });
    elements.forEach(element => observer.observe(element));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
